import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { getEnvVar } from '../../utilities/getEnvs.js';
import { fetchWithFailover } from './restDefaultClient.js';

var authLogout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var url;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = '/auth/logout';
            return _context.abrupt("return", fetchWithFailover(url, {
              method: 'DELETE',
              credentials: 'include',
              headers: {
                APPLICATION_ID: getEnvVar('APPLICATION_ID')
              }
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function authLogout() {
    return _ref.apply(this, arguments);
  };
}();
var logoutInOldApp = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var url;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            url = '/logout.html?reason=stopSSO';
            return _context2.abrupt("return", fetch(url, {
              method: 'POST',
              credentials: 'include'
            }));
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function logoutInOldApp() {
    return _ref2.apply(this, arguments);
  };
}();

export { authLogout, logoutInOldApp };
